<template>
  <div class="popover-div" @mouseenter.once="coachMarkSeen">
    <b-button :id="id" :data-testid="id" class="popover-button">
      <span class="circle" style="animation-delay: 0s"></span>
      <span class="circle" style="animation-delay: 1s"></span>
      <span class="circle" style="animation-delay: 2s"></span>
      <span class="circle" style="animation-delay: 3s"></span>
    </b-button>
    <b-popover :target="id" triggers="hover" :delay="{show: 0, hide: delay}" :placement="placement" custom-class="promote-activity">
      <div>
        <div v-if="image" class="popover-image">
          <img v-if="image=='comments'" :src="ConversationImage"/>
        </div>
        <div class="popover-heading">
          {{ heading }}
        </div>
        <div class="popover-content">
          {{ content }}
        </div>
        <div v-if="learnmore">
          <b-button class="learn_more" :href="learnmore" target="_blank" variant="light">Learn More</b-button>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<style scoped lang="scss">
@import '../../packs/application.scss';

.popover-image {
  padding: 1rem 1rem 0rem 1rem;
}

/deep/ .popover-body {
  width: 16rem;
  background: #007AFF;
  color: white;
  text-align: center;
}

.popover-heading {
  font-size: 1.5rem;
  padding: 1rem;
}

.popover-content {
  font-size: 0.75rem;
  padding: 0rem 1rem 1rem 1rem;
}

.learn_more {
  width: 100%;
  margin-bottom: 1rem;
  color: $bright-blue;
  border-radius: 0px;
  font-size: 0.75rem;
}

.popover-div {
  height: 0rem;

  #popover-target-overview {
    bottom: 0.45rem;
    right: 7.8rem;
  }

  #popover-target-comments {
    bottom: 1.5rem;
    right: 1rem;
  }

  #popover-target-activity {
    bottom: 1.5rem;
    left: 12rem;
  }

  .popover-button {
    position: relative;
    background: transparent;
    border: none;
    height: 2rem;
    width: 2rem;
    padding: 0;
  }

  .circle {
    border-radius: 50%;
    background: #F09819;
    width: 1rem;
    height: 1rem;
    position: absolute;
    opacity: 0;
    margin: 0;
    top: 0.5rem;
    left: 0.5rem;
    animation: scaleIn 4s infinite cubic-bezier(.36, .11, .89, .32);
  }

  @keyframes scaleIn {
    from {
      transform: scale(.5, .5);
      opacity: .5;
    }
    to {
      transform: scale(2.5, 2.5);
      opacity: 0;
    }
  }
}

</style>

<style lang="scss">
  @import '@/packs/colors.scss';

  .bs-popover-right.promote-activity > .arrow::after {
    border-right-color: $bright-blue;
  }
</style>

<script>
import track from '@/src/tracking';
import ConversationImage from '../../images/icons-conversation.svg'

export default {
  props: {
    id: String,
    heading: String,
    content: String,
    placement: String,
    image: String,
    event: String,
    learnmore: String,
    utmmedium: String,
    utmcampaign: String,
    eventParams: Object,
    delay: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      ConversationImage
    }
  },
  methods: {
    coachMarkSeen: async function() {
      let eventName = this.event;
      let utm_medium = this.utmmedium || "";
      let utm_campaign = this.utmcampaign || "";
      const properties = {
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        ...this.eventParams
      }
      track(eventName, properties)
    }
  }
}
</script>
